// extracted by mini-css-extract-plugin
export default {"section":"Values_section__6fSqM","heading":"Values_heading__PhOKy","grid":"Values_grid__SaqWU","card":"Values_card__Do+Qn","iconWrap":"Values_iconWrap__EcY9z"};